module.exports = __webpack_public_path__ + "BradescoSans-SemiBold-BZXyHHda.d868de08699c8cb72860.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/bradesco/BradescoSans-SemiBold-BZXyHHda.woff2
// module id = ../../../../../src/assets/fonts/bradesco/BradescoSans-SemiBold-BZXyHHda.woff2
// module chunks = styles